<div (click)="$event.stopPropagation(); update()" class="renderer-header-container">

  <span *ngIf="state === stateEnums.ALL">Select None</span>
  <span *ngIf="state !== stateEnums.ALL">Select All</span>

</div>

